module.exports = __webpack_public_path__ + "img/hr-branch-particle-shadow-03.b4be8989.png";